// Discount Tag Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to update discount tag
  function updateDiscountTag(productId, variantId) {
    const discountTag = document.querySelector(`[data-product-id="${productId}"]`);
    if (!discountTag) return;
    
    // Get variant data from the page
    const variantSelect = document.querySelector(`select[name="id"][data-product-id="${productId}"]`);
    if (!variantSelect) return;
    
    const selectedOption = variantSelect.querySelector(`option[value="${variantId}"]`);
    if (!selectedOption) return;
    
    const price = parseInt(selectedOption.dataset.price);
    const comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice) : 0;
    
    if (comparePrice && comparePrice > price) {
      const discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
      const discountPercentage = discountTag.querySelector('.discount-percentage');
      if (discountPercentage) {
        discountPercentage.textContent = `${discountPercent}%`;
      }
      discountTag.style.display = 'block';
    } else {
      discountTag.style.display = 'none';
    }
  }
  
  // Listen for variant changes
  const variantSelects = document.querySelectorAll('select[name="id"]');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const variantId = this.value;
      updateDiscountTag(productId, variantId);
    });
  });
  
  // Initialize discount tags on page load
  const discountTags = document.querySelectorAll('.product-discount-tag');
  discountTags.forEach(tag => {
    const productId = tag.dataset.productId;
    const variantId = tag.dataset.variantId;
    updateDiscountTag(productId, variantId);
  });
}); 